import * as THREE from "three";
import { MODEL_MAT, eMatType } from "../constants/materials";
import { loader } from "./loader";

export default class MatUtils {
  static MAT_HASH: Record<string, THREE.Material> = {};

  private static generateID = (options: any) => {
    let id = "";

    for (const key in options) {
      id += `_${key}_${options[key]}`;
    }
    return id;
  };

  static async getMat(
    type: number,
    options: any,
    texture: any,
    material: any = null,
    loadSky: boolean = false
  ) {
    const matID = this.generateID({ ...options, texture, type, loadSky });

    let matToAdd: THREE.Material | undefined;
    if (!this.MAT_HASH[matID] || loadSky) {
      switch (type) {
        case eMatType.BASIC:
          matToAdd = await this.createMat(
            THREE.MeshBasicMaterial,
            options,
            texture
          );
          break;
        case eMatType.PHYSICAL:
          matToAdd = await this.createMat(
            THREE.MeshPhysicalMaterial,
            options,
            texture
          );
          break;
        case eMatType.PHONG:
          matToAdd = await this.createMat(
            THREE.MeshPhongMaterial,
            options,
            texture
          );
          break;
        case eMatType.STANDARD:
          matToAdd = await this.createMat(
            THREE.MeshStandardMaterial,
            options,
            texture
          );
          break;
        default:
          if (material) {
            matToAdd = await this.createMat(material, options, texture);
          }
          break;
      }
      if (matToAdd) {
        MatUtils.MAT_HASH[matID] = matToAdd;
      }
    }
    return MatUtils.MAT_HASH[matID].clone();
  }

  static async createMat(constructor: any, options: any, maps: any = {}) {
    const textures: Record<string, THREE.Texture> = {};

    await Promise.all(
      Object.keys(maps).map(async (mapName) => {
        const texture = await loader.loadTexture(maps[mapName]);
        textures[mapName] = texture;
      })
    );

    const mat = new constructor({ ...options, ...textures });
    return mat;
  }
}
